export const iconFontAwesomeReligionScrollTorah = (
	<i className="fa-solid fa-scroll-torah"></i>
);
